import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import './AdvancedFiltersButton.css';

export default function AdvancedFiltersButton({ activeCount, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`advanced-filters-button ${activeCount > 0 ? 'active' : ''}`}
    >
      <SlidersHorizontal className="w-5 h-5" />
      <span>Filtros Avançados</span>
      {activeCount > 0 && (
        <span className="advanced-filters-button__badge">{activeCount}</span>
      )}
    </button>
  );
}
